import { Link } from "react-router-dom";
import Services from "./Services";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import { CONTACT_INFO, HERO_STATS } from "../utils/constants";
import { IconWhatsapp } from "../utils/icons";
import useDocumentMeta from "../utils/useDocumentMeta";
import heroImage from "../../assets/hero-minimal-v2.webp";
import manojPortrait from "../../assets/manoj-kumar.jpeg";
import AmbientBackground from "./AmbientBackground";
import { MagneticButton } from "./InteractiveSurface";

const Body = () => {
  useDocumentMeta(
    "PVM Consultants | Manoj Kumar — Financial Consultant, Ghaziabad",
    "20+ years managing investments, insurance, tax filing and loans for working professionals. Personal, full-service financial guidance from Manoj Kumar, PVM Consultants, Ghaziabad."
  );

  return (
    <>
      <section className="hero">
        <div className="hero-shell">
          <div className="hero-content">
            <span className="hero-kicker">Twenty years of trusted guidance</span>
            <h1>Your financial life, <span>thoughtfully managed.</span></h1>
            <p className="hero-subtext">
              One experienced advisor for investments, insurance, tax and loans—so
              every decision works as part of one clear plan.
            </p>
            <div className="hero-ctas">
              <MagneticButton as={Link} to="/contact" className="btn btn-primary magnetic-cta">
                Start a conversation
              </MagneticButton>
              <a className="hero-text-link" href={CONTACT_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                <IconWhatsapp size={18} /> WhatsApp Manoj
              </a>
            </div>
            <div className="hero-stats" aria-label="PVM Consultants at a glance">
              {HERO_STATS.map((stat) => (
                <div className="hero-stat" key={stat.label}><strong>{stat.value}</strong><span>{stat.label}</span></div>
              ))}
            </div>
          </div>

          <div className="hero-visual">
            <img
              src={heroImage}
              alt="A leather financial portfolio and fountain pen on a quiet stone desk"
            />
          </div>
        </div>

      </section>

      <section className="why-choose">
        <div className="section-heading">
          <span className="eyebrow">A more personal approach</span>
          <h2>One advisor. The complete picture.</h2>
        </div>
        <p className="why-choose-text">
          Most people juggle a different advisor for every part of their money —
          one for taxes, another for insurance, someone else for stock trading —
          with no one keeping track of the full picture. Manoj manages your
          entire financial life personally, so you always have a single,
          dependable person who truly knows your portfolio and has your back.
        </p>
      </section>

      <Services />

      <section className="process-section">
        <div className="process-heading">
          <span className="eyebrow">How it works</span>
          <h2>A considered process, kept simple.</h2>
          <p>Every relationship begins with understanding the complete picture—not recommending a product.</p>
        </div>
        <div className="process-steps">
          <article>
            <span>01</span>
            <h3>Discover</h3>
            <p>We begin with your income, responsibilities, existing finances and the goals that matter to you.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Plan</h3>
            <p>Manoj brings investments, protection, tax and borrowing into one clear, practical direction.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Guide</h3>
            <p>Your plan is reviewed personally as markets, regulations and your own circumstances evolve.</p>
          </article>
        </div>
      </section>

      <section className="calculators-promo">
        <div className="calculators-promo-inner">
          <AmbientBackground />
          <div>
            <h2>Not sure where you stand? Run the numbers.</h2>
            <p>Free SIP growth and life insurance cover calculators — no signup needed.</p>
          </div>
          <MagneticButton as={Link} to="/tools" className="btn btn-primary magnetic-cta">
            Try the Calculators
          </MagneticButton>
        </div>
      </section>

      <Testimonials />

      <section className="standards-section">
        <div className="standards-statement">
          <span className="eyebrow">Our advisory philosophy</span>
          <h2>Clarity before products. Relationships before transactions.</h2>
          <p>Recommendations begin with what fits your wider financial life—not what is easiest to sell.</p>
        </div>
        <div className="standards-details">
          <div><span>Experience</span><strong>20+ years in financial services</strong></div>
          <div><span>Continuity</span><strong>Guidance managed personally by Manoj</strong></div>
          <div><span>Coverage</span><strong>Investments, insurance, tax, loans and advisory</strong></div>
          <div><span>Affiliation</span><strong>Share-market and Demat services through Prabhudas Liladhar</strong></div>
        </div>
        <p className="standards-disclosure">Trading and Demat execution is facilitated through the affiliated regulated platform. Financial products involve risk and should be selected according to individual circumstances.</p>
      </section>
      <FAQ />

      <section className="cta-banner">
        <AmbientBackground />
        <figure className="cta-advisor">
          <img src={manojPortrait} alt="Manoj Kumar, financial consultant at PVM Consultants" />
          <figcaption><strong>Manoj Kumar</strong><span>Financial Consultant</span></figcaption>
        </figure>
        <div className="cta-banner-copy">
          <span className="eyebrow">A clearer financial future</span>
          <h2>Ready to put your finances on autopilot?</h2>
          <p>Get a free, no-obligation consultation and see where you stand.</p>
        </div>
        <div className="cta-banner-actions">
          <a className="cta-call-link" href={CONTACT_INFO.callLink}>
            Call {CONTACT_INFO.phoneDisplay}
          </a>
          <MagneticButton as={Link} to="/contact" className="btn btn-primary magnetic-cta">
            Book a consultation
          </MagneticButton>
        </div>
      </section>
    </>
  );
};

export default Body;
